export const carleadDefaultChannelFlow = {
  initial: {
    name: 'manufacturer',
    next: ['mainType'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mainType: {
    name: 'mainType',
    next: ['builtDate'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  builtDate: {
    name: 'builtDate',
    next: ['bodyType'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  bodyType: {
    name: 'bodyType',
    next: ['fuelType'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  fuelType: {
    name: 'fuelType',
    next: ['mainTypeDetail'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mainTypeDetail: {
    name: 'mainTypeDetail',
    next: ['horsePower'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  horsePower: {
    name: 'horsePower',
    next: ['gearType'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  gearType: {
    name: 'gearType',
    next: ['doorCount'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  doorCount: {
    name: 'doorCount',
    next: ['mainTypeSub'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mainTypeSub: {
    name: 'mainTypeSub',
    next: ['mileage'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mileage: {
    name: 'mileage',
    next: ['SELLPOINT'],
    nodeType: 'normalField',
    inputFieldType: 'text'
  },
  SELLPOINT: {
    name: 'SELLPOINT',
    cookieName: 'surveySellpoint',
    next: ['SELL_TYPES', 'BUY_CAR'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      SELL_TYPES: ['SELLPOINT_NOW', 'SELLPOINT_4_WEEKS', 'SELLPOINT_3_MONTHS'],
      BUY_CAR: ['SELLPOINT_NOT_PLANNED']
    }
  },
  SELL_TYPES: {
    name: 'SELL_TYPES',
    cookieName: 'surveySelltypes',
    next: ['BUY_CAR'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      BUY_CAR: ['DEALER', 'PRIVATE']
    }
  },
  BUY_CAR: {
    name: 'BUY_CAR',
    next: ['channelType'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      channelType: ['YES', 'NO']
    }
  },
  channelType: {
    name: 'channelType',
    next: ['email', 'mobile'],
    nodeType: 'normalField',
    inputFieldType: 'select',
    guards: {
      email: ['email'],
      mobile: ['whatsapp', 'text']
    }
  },
  email: {
    name: 'email',
    next: ['finish'],
    nodeType: 'normalField',
    inputFieldType: 'text'
  },
  mobile: {
    name: 'mobile',
    next: ['finish'],
    nodeType: 'normalField',
    inputFieldType: 'text'
  },
  finish: {
    name: 'finish',
    nodeType: 'normalField',
    inputFieldType: 'select',
    next: []
  }
};
export const carleadWhatsappChannelFlow = {
  ...carleadDefaultChannelFlow,
  channelType: {
    name: 'channelType',
    next: ['email', 'mobile'],
    nodeType: 'normalField',
    inputFieldType: 'select',
    guards: {
      email: ['email'],
      mobile: ['whatsapp']
    }
  }
};